import { trackNavigation, trackEvent } from '../../utils/analytics';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const links = [
    { text: 'Restaurant Packs', href: '#restaurant' },
    { text: 'Ceramic Edition', href: '#home-bbq' },
    { text: 'Bark-n-Dip', href: '#for-pets' },
    { text: 'Contact', href: 'mailto:contact@ribndip.com' },
  ];

  const handleLinkClick = (linkText: string, href: string) => {
    if (href.startsWith('mailto:')) {
      trackEvent('contact_click', { contact_method: 'email', link_text: linkText });
    } else if (href.startsWith('#')) {
      trackNavigation('footer_link', href.substring(1));
    }
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <h3 className="footer__logo">Rib-n-Dip</h3>
            <p className="footer__tagline">No Rib Left Dry</p>
          </div>

          <nav className="footer__nav">
            {links.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="footer__link"
                onClick={() => handleLinkClick(link.text, link.href)}
              >
                {link.text}
              </a>
            ))}
          </nav>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © {currentYear} Rib-n-Dip. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
